import { useFichaAnexos } from "./use-ficha-anexos";
import { FichaAnexosView } from "./view-ficha-anexos";
import type { FichaAnexosProps } from "./types-ficha-anexos";

export function FichaAnexos(props: FichaAnexosProps) {
  const vm = useFichaAnexos(props);

  return <FichaAnexosView {...vm} />;
}

export type * from "./types-ficha-anexos";
